@if (dossier(); as dossier) {
	<section class="u-page-section">
		<div class="u-container">
			<div class="c-help-bar">
				<div></div>

				<div (click)="showCloseModal.set(true)">
					<span class="u-text--medium u-text--xlight">Rapportage afsluiten</span>

					<button class="c-btn-round u-m-left--xxs" title="Sluiten" type="button">
						<span class="icon-close"></span>
					</button>
				</div>
			</div>

			@let report = config()?.report;
			<h1 class="u-heading--xl-bold u-m-bottom--md">{{ report === true ? 'Rapportage' : report }}</h1>
			<p class="u-m-bottom--md"></p>

			<main class="u-content">
				<div class="title-bar">
					<h1 class="u-heading--xl">
						{{ dossier.baseProduct?.groupName || dossier['projectTitle'] || dossier.id || 'Onbekend' }}
					</h1>

					<hr class="hr-full"/>

					<ng-content></ng-content>

					<hr class="hr-full"/>

					<div class="buttons">
						<div></div>
						<button (click)="trySubmit()" class="c-btn">Rapporteren</button>
					</div>
				</div>
			</main>
		</div>
	</section>

	<tvcore-modal (close)="close($event)" [(visible)]="showCloseModal" cancelButton="Annuleren" okButton="Afsluiten">
		<p class="u-text--bold">Weet je zeker dat je deze rapportage wilt afsluiten?</p>
	</tvcore-modal>

	<tvcore-modal (close)="submit($event)" [(visible)]="showSubmitModal" cancelButton="Annuleren" okButton="Indienen">
		<p class="u-text--bold">Ben je zeker dat je deze rapportage wilt indienen?</p>
	</tvcore-modal>
}
